module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/layout-vertical-3a3cc9571033f7ff60ce58809d217192.svg";